<template>
  <div class="tabpane_content">
    <div class="content_header">
      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px;"
        @click="createRequire">
        发布需求
      </el-button>
      <el-input
        style="width:300px;margin-right: 10px;"
        size="small"
        placeholder="请输入需求名称"
        suffix-icon="el-icon-search"
        v-model="searchCondition.keywords"
        @keyup.native.enter="onSearch">
      </el-input>
      <el-select
        size="small"
        style="width:200px;margin-right: 10px;"
        v-model="searchCondition.logicStatus"
        :clearable="true"
        placeholder="请选择需求状态"
        @change="onSearch">
        <el-option
          v-for="item in requireStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-select
        size="small"
        style="width:200px;margin-right: 10px;"
        v-model="searchCondition.serviceTypeId"
        :clearable="true"
        placeholder="请选择服务类型"
        @change="onSearch">
        <el-option
          v-for="item in serviceTypeOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button
        type="primary"
        plain
        size="small"
        :loading="exportBtnLoading"
        @click="onExport">
        导出
      </el-button>
    </div>
    <div class="content_main">
      <el-table
        v-loading="loading"
        :header-cell-style="headerCellStyle"
        :data="tableData"
        style="width: 100%"
        @row-click="onDetail">
        <el-table-column
          label="序号"
          type="index"
          :index="indexMethod">
        </el-table-column>
        <el-table-column
          prop="serviceTypeName"
          label="服务类型">
        </el-table-column>
        <el-table-column
          prop="title"
          label="需求名称">
        </el-table-column>
        <el-table-column
          prop="contacts"
          label="联系人">
        </el-table-column>
        <el-table-column
          prop="contactMobile"
          label="联系人手机">
        </el-table-column>
        <el-table-column
          prop="reviewerName"
          label="审核人">
        </el-table-column>
        <el-table-column
          prop="operatorAt"
          label="审核时间">
        </el-table-column>
        <el-table-column
          width="100px"
          label="操作">
          <template
            slot-scope='scoped'>
            <span
              class="text_color_active tw-cursor-pointer tw-mr-5px"
              @click.stop="onEdit(scoped.row)">
              编辑
            </span>
            <span
              v-if="canRevoke(scoped.row)"
              class="text_color_danger tw-cursor-pointer"
              @click.stop="onCancel(scoped.row)">
              下架
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content_footer">
      <el-pagination
        hide-on-single-page
        background
        @current-change="pageNumChange"
        :current-page.sync="pagination.pageNum"
        :page-size="pagination.pageSize"
        layout="prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'
import globalVar from '@/configs/globalVar'
import { renderExcel } from '@/utils/excel.export.js'
export default {
  data () {
    return {
      loading: false,
      exportBtnLoading: false,
      // 搜索对象
      searchCondition: {
        keywords: '',
        logicStatus: '',
        serviceTypeId: ''
      },
      serviceTypeOptions: [],
      tableData: [],
      // 分页对象
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    // 表格头
    headerCellStyle () {
      return this.$store.state.headerCellStyle
    },
    globalVar () {
      return globalVar
    },
    requireStatusOptions () {
      return globalVar.REQUIRE_STATUS_OPTIONS.filter(item => {
        return item.value !== globalVar.REQUIRE_STATUS_SUBMITTED
      })
    },
    // 可以被下架
    canRevoke () {
      return (item) => {
        return item.logicStatus === globalVar.REQUIRE_STATUS_PUBLISHED
      }
    }
  },
  created () {
    this.getServiceTypeOptions()
    this.getTableData()
  },
  methods: {
    getServiceTypeOptions () {
      api.getServiceTypeOptions().then(res => {
        if (res.data.code === 0) {
          this.serviceTypeOptions = res.data.data.list
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('请求出错')
      })
    },
    // 获取列表
    getTableData (pageNum) {
      this.loading = true
      const searchVar = this.getSearchVar()
      api.getRequireList({
        ...searchVar,
        pageNum,
        pageSize: this.pagination.pageSize
      }).then(res => {
        if (res.data.code === 0) {
          this.pagination.pageNum = res.data.data.currentPage
          this.pagination.total = res.data.data.total
          this.tableData = res.data.data.list
        } else {
          this.$message.error(res.data.message)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        console.log(err)
        this.$message.error('请求出错')
      })
    },
    // 下架需求
    onCancel (item) {
      this.$msgbox({
        title: '撤销需求',
        message: '确定要撤销该需求？',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.cancelRequire(item, instance, done)
          } else {
            done()
          }
        }
      })
    },
    cancelRequire (item, instance, done) {
      instance.confirmButtonLoading = true

      api.editRequireStatus(item.id, {
        status: globalVar.REQUIRE_STATUS_CANCELLED
      }).then(res => {
        if (res.data.code === 0) {
          this.$message.success('操作成功')
          this.getTableData(this.pagination.pageNum)
        } else {
          this.$message.error(res.data.message)
        }
        done()
      }).catch(err => {
        console.log(err)
        this.$message.error('请求出错')
      }).finally(() => {
        instance.confirmButtonLoading = false
      })
    },
    // 创建需求
    createRequire () {
      window.open('/resource-require/require/create', '_blank')
    },
    // 导出需求为excel
    onExport () {
      const searchVar = this.getSearchVar()
      const { logicStatus, keywords, serviceTypeId } = searchVar
      this.exportBtnLoading = true
      api.requireExport({
        serviceTypeId,
        status: logicStatus,
        keywords
      }).then(res => {
        if (res.data.code === 0) {
          console.log('需求导出', res.data.data)
          const { list, header } = res.data.data
          renderExcel(list, header, '需求数据')
        } else {
          this.$message.error(res.data.message)
        }
        this.exportBtnLoading = false
      }).catch(err => {
        this.exportBtnLoading = false
        console.log(err)
        this.$message.error('请求出错')
      })
    },
    // 点击行 进入需求 详情
    onDetail (row) {
      const { href } = this.$router.resolve({
        path: `/resource-require/require/detail/${row.id}`
      })
      window.open(href, '_blank')
    },
    // 点击编辑 进入编辑界面
    onEdit (row) {
      const { href } = this.$router.resolve({
        path: `/resource-require/require/edit/${row.id}`
      })
      window.open(href, '_blank')
    },
    onSearch () {
      this.getTableData(1)
    },
    // 获取搜索条件
    getSearchVar () {
      // 把非已提交的需求状态筛选出来
      const statusList = this.globalVar.REQUIRE_STATUS_OPTIONS.filter(item => {
        return item.value !== globalVar.REQUIRE_STATUS_SUBMITTED
      }).map(item => {
        return item.value
      })
      // 再把状态以否号分隔
      const logicStatus = this.searchCondition.logicStatus || statusList.join(',')
      const keywords = this.searchCondition.keywords
      const serviceTypeId = this.searchCondition.serviceTypeId
      return {
        logicStatus,
        keywords,
        serviceTypeId
      }
    },
    indexMethod (index) {
      return this.pagination.pageSize * (this.pagination.pageNum - 1) + index + 1
    },
    // 页码变化
    pageNumChange (pageNum) {
      this.getTableData(pageNum)
    }
  }
}
</script>

<style lang="scss" scoped>
  .tabpane_content {
    padding: 15px 25px;
    .content_header {
      display: flex;
      margin-bottom: 20px;
    }
    .content_main {
      margin-bottom: 20px;
    }
    .content_footer {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
    }
  }
</style>
